import React, { useState, useCallback } from "react";
import axios from "axios";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
// config
import configData from "../../config/config.json";
// img
import deletepic from "../../images/register-business/delete.png";

const Modal = (props) => {
  const {
    imagesList,
    setImagesList,
    deleteItem,
    setAddPicOrDelete,
    alertHandeler,
    setProgress,
    coverId,
    setCoverId,
  } = props;

  const [centredModal, setCentredModal] = useState(false);

  const [disable, setDisable] = useState(false);

  const toggleShow = () => {
    if (!disable) {
      setCentredModal(!centredModal);
    }
  };

  const { selectedImage, setSelectedImage } = props;
  const { showAlert, setshowAlert } = props;
  const { base64String, setbase64String } = props;
  // const { setAddPicOrDelete } = props;

  const handleInputChange = useCallback(
    (event) => {
      // window.location.reload();

      // setSelectedImage(event.target.value);
      setSelectedImage("");
      // setshowAlert(true);
      // setAddPicOrDelete("delete");

      setbase64String(false);
    },
    [setSelectedImage]
  );

  const handleInputChangeApi = () => {
    // window.location.reload();

    setSelectedImage(false);
    // setAddPicOrDelete("delete");
    // setshowAlert(true);
    setbase64String(false);
  };

  const deleteImage = () => {
    setProgress({});

    let newList;

    if (deleteItem.name) {
      newList = imagesList.filter((item) => item.name !== deleteItem.name);
      toggleShow();
      alertHandeler();
      setImagesList(newList);

      if (deleteItem == coverId) {
        setCoverId(newList[0] ? newList[0] : null);
      }
    } else {
      // photo comes from api
      const deletePhoto = {
        Id: getCookie("BizUuid"),
        BPId: deleteItem.bpId,
        BId: getCookie("BizId"),
      };

      let formData = new FormData();

      formData.append("BPId", deleteItem.bpId);
      formData.append("BId", getCookie("BizId"));
      formData.append("Id", getCookie("BizUuid"));

      setDisable(true);

      axios
        .delete(
          configData.API_DOMAIN +
            `/api/v1/Businesses/${getCookie("BizUuid")}/photos`,
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              BizId: getCookie("BizId"),
              Authorization: "Bearer " + getCookie("token"),
            },
            data: formData,
          }
        )
        .then((response) => {
          setDisable(false);

          if (response.data.isSuccess) {
            // success
            newList = imagesList.filter(
              (item) => item.bpId !== deleteItem.bpId
            );
            toggleShow();
            alertHandeler();
            setImagesList(newList);
          }

          if (deleteItem == coverId) {
            setCoverId(newList[0] ? newList[0] : null);
          }
        })
        .catch((error) => {
          setDisable(false);
          // alert(error);
        });
    }
    setAddPicOrDelete("delete");
  };

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      <img
        onClick={toggleShow}
        src={deletepic}
        alt="delete"
        className="s7-img-delete"
      />
      <MDBModal
        staticBackdrop={disable}
        tabIndex="-1"
        show={centredModal}
        setShow={setCentredModal}
      >
        <MDBModalDialog centered>
          <MDBModalContent className={"modal_delete_img"}>
            <MDBModalHeader className="modal-delete-img-header">
              <MDBModalTitle></MDBModalTitle>
              <MDBBtn
                className="btn-close button_delete_modal_img"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div>
                <p className={"text_modal_delete_img"}>{props.text}</p>
              </div>
              <div className="a_s_c">
                <button
                  // onClick={props.api ? handleInputChangeApi : handleInputChange}
                  disabled={disable}
                  onClick={deleteImage}
                  className="button_modal_delete_img"
                >
                  حذف شود
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};

export default Modal;
